import { FC  } from 'react';
import { useSelector } from 'react-redux';
import { Bubble } from '@ant-design/x';
import type { BubbleProps } from '@ant-design/x';
import type { RootState } from '@@store/index';
import './index.less';

export interface BubbleXPropsType extends BubbleProps {
    className?: any;
}

const BubbleX: FC<BubbleXPropsType> = (props) => {
    const {
        className = '',
        ...rest
    } = props;

    const curTheme = useSelector((state: RootState) => state.theme);

    return (
        <Bubble
            className={`${curTheme}-base-bubble ${className}`}
            {...rest}
        />
    );
};

export default BubbleX;
